export default "__VITE_ASSET__CMTPI5jt__"